const PENDING_STARTED_AT_KEY = 'app_magic_link_pending_started_at';
const PENDING_CHALLENGE_ID_KEY = 'app_magic_link_pending_challenge_id';
const PENDING_METHOD_KEY = 'app_magic_link_pending_method';
const PENDING_DESTINATION_KEY = 'app_magic_link_pending_destination';
const VERIFIED_SESSION_KEY = 'app_second_factor_verified';
const VERIFIED_UID_KEY = 'app_second_factor_verified_uid';

export function readPendingStartedAt() {
  try {
    const v = sessionStorage.getItem(PENDING_STARTED_AT_KEY);
    if (!v) return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

export function writePendingStartedAt(ts) {
  try {
    if (!ts) {
      sessionStorage.removeItem(PENDING_STARTED_AT_KEY);
      sessionStorage.removeItem(PENDING_METHOD_KEY);
      sessionStorage.removeItem(PENDING_DESTINATION_KEY);
    } else {
      sessionStorage.setItem(PENDING_STARTED_AT_KEY, String(ts));
    }
  } catch {
    // ignore storage failures
  }
}

export function readPendingChallengeId() {
  try {
    const v = sessionStorage.getItem(PENDING_CHALLENGE_ID_KEY);
    return v ? String(v) : null;
  } catch {
    return null;
  }
}

export function writePendingChallengeId(v) {
  try {
    if (!v) {
      sessionStorage.removeItem(PENDING_CHALLENGE_ID_KEY);
    } else {
      sessionStorage.setItem(PENDING_CHALLENGE_ID_KEY, String(v));
    }
  } catch {
    // ignore
  }
}

export function readPendingMethod() {
  try {
    const v = String(sessionStorage.getItem(PENDING_METHOD_KEY) || '').trim().toLowerCase();
    if (v === 'sms' || v === 'email') return v;
    return '';
  } catch {
    return '';
  }
}

export function writePendingMethod(v) {
  try {
    if (!v) {
      sessionStorage.removeItem(PENDING_METHOD_KEY);
    } else {
      sessionStorage.setItem(PENDING_METHOD_KEY, v === 'sms' ? 'sms' : 'email');
    }
  } catch {
    // ignore
  }
}

export function readPendingDestination() {
  try {
    return String(sessionStorage.getItem(PENDING_DESTINATION_KEY) || '');
  } catch {
    return '';
  }
}

export function writePendingDestination(v) {
  try {
    if (!v) {
      sessionStorage.removeItem(PENDING_DESTINATION_KEY);
    } else {
      sessionStorage.setItem(PENDING_DESTINATION_KEY, String(v));
    }
  } catch {
    // ignore
  }
}

export function clearPendingSecondFactor() {
  const hadPending = isPendingSecondFactorActive();
  writePendingStartedAt(null);
  writePendingChallengeId(null);
  if (hadPending) {
    try {
      window.dispatchEvent(new CustomEvent('app-second-factor-complete'));
    } catch {
      // ignore
    }
  }
}

/** Persists across refresh (sessionStorage) and browser restarts (localStorage, keyed by uid). */
export function markSecondFactorVerifiedSession(uid) {
  try {
    sessionStorage.setItem(VERIFIED_SESSION_KEY, '1');
    if (uid) {
      localStorage.setItem(VERIFIED_UID_KEY, String(uid));
    }
  } catch {
    // ignore storage failures
  }
}

export function isSecondFactorVerifiedSession(uid) {
  try {
    if (sessionStorage.getItem(VERIFIED_SESSION_KEY) === '1') {
      return true;
    }
    if (!uid) {
      return false;
    }
    return localStorage.getItem(VERIFIED_UID_KEY) === String(uid);
  } catch {
    return false;
  }
}

export function clearSecondFactorVerifiedSession() {
  try {
    sessionStorage.removeItem(VERIFIED_SESSION_KEY);
    localStorage.removeItem(VERIFIED_UID_KEY);
  } catch {
    // ignore storage failures
  }
}

export function generateChallengeId() {
  const bytes = new Uint8Array(18);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function isPendingSecondFactorActive() {
  return Boolean(readPendingStartedAt()) && Boolean(readPendingChallengeId());
}

export function isAuthShellPath(pathname = '') {
  const path = String(pathname || '');
  return path.startsWith('/app/login')
    || path.startsWith('/app/magic-link')
    || path.startsWith('/app/impersonate');
}

/** Login / magic-link routes should not apply company theme (avoids repaint during 2FA). */
export function isAuthShellRoute() {
  if (typeof window === 'undefined') return false;
  const path = window.location.pathname || '';
  const hash = window.location.hash || '';
  const hashPath = hash.startsWith('#') ? hash.slice(1).split('?')[0] : '';
  return isAuthShellPath(path) || isAuthShellPath(hashPath);
}

export function shouldDeferCompanyTheme(pathname) {
  if (pathname && isAuthShellPath(pathname)) return true;
  if (!pathname && isAuthShellRoute()) return true;
  if (isPendingSecondFactorActive()) return true;
  if (Boolean(readPendingStartedAt())) return true;
  return false;
}
